export default __webpack_public_path__ + "static/media/edge-tipped.f59d6015.PNG";